import {Component, OnInit, inject, output, input, effect} from '@angular/core';
import {ProjectStatus, ViewMode, Right} from "../../../interfaces";
import {UntypedFormBuilder, UntypedFormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {DataService} from "../../../../services/data.service";
import {ProjectService} from "../../../../services/project.service";
import moment from 'moment';
import {AccessService} from "../../../../services/access.service";
import {ToastrService} from "ngx-toastr";
import {NgIf, NgFor, DecimalPipe, DatePipe} from '@angular/common';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {YesNoPipe} from '../../../../pipes/yes-no.pipe';

@Component({
    selector: 'app-project-completion',
    templateUrl: './project-completion.component.html',
    styleUrl: './project-completion.component.scss',
    imports: [NgIf, TooltipModule, FormsModule, ReactiveFormsModule, NgFor, DecimalPipe, DatePipe, YesNoPipe]
})
export class ProjectCompletionComponent implements OnInit {

    accessService = inject(AccessService);
    projectService = inject(ProjectService);
    private dataService = inject(DataService);
    private fb = inject(UntypedFormBuilder);
    private toastrService = inject(ToastrService);

    readonly PID = input.required<any>();
    readonly reloadTrigger = input<number>(0);

    readonly changeProject = output();
    readonly changeViewMode = output<boolean>();

    readonly ViewMode = ViewMode;
    readonly ProjectStatus = ProjectStatus;
    readonly Right = Right;

    viewMode!: ViewMode;
    project: any;
    form!: UntypedFormGroup;

    private reloadEffect = effect(() => {
        if (this.reloadTrigger() > 0) {
            this.getProject();
        }
    })

    ngOnInit(): void {
        this.viewMode = this.PID() == '0' ? ViewMode.INSERT : ViewMode.VIEW;

        this.form = this.fb.group({
            id: [null],
            status: [null],
            completion_goals_comment: [''],
            completion_time_comment: [''],
            completion_costs_comment: [''],
            total_costs: [''],
            cost_budget: [''],
            cost_actual: [''],
        });

        if (this.PID() !== '0') {
            this.getProject();
        }
    }

    setMode(viewMode: ViewMode): void {
        this.viewMode = viewMode;
        if (this.viewMode == ViewMode.EDIT) {
            this.changeViewMode.emit(true);
        } else {
            this.changeViewMode.emit(false);
        }
    }

    getProject(): void {
        this.dataService.request('Project/get', {
            PID: this.PID()
        }).subscribe(response => {
            this.project = response.project;

            this.project.goals.forEach(goal => goal.completed = goal.completed == '1');
            this.project.total_costs = this.project.costs.reduce((carry, next) => {
                return carry + parseInt(next.amount);
            }, 0);

            if (this.project.invoices.length > 0) {
                this.project.last_invoice_amount = this.project.invoices[this.project.invoices.length - 1].amount;
            } else {
                this.project.last_invoice_amount = 0;
            }

            this.project.date_deviation = this.project.dates_end_planned && this.project.date_completion_filed ? moment(this.project.date_completion_filed).diff(moment(this.project.dates_end_planned), 'days') : 0;

            this.patchForm();
        });
    }

    patchForm(): void {
        this.form.patchValue({
            id: this.project.id,
            status: this.project.status,
            completion_goals_comment: this.project.completion_goals_comment,
            completion_time_comment: this.project.completion_time_comment,
            completion_costs_comment: this.project.completion_costs_comment,
            total_costs: this.project.total_costs,
            cost_budget: this.project.cost_budget,
            cost_actual: this.project.cost_actual,
        });
    }

    update(): void {
        this.dataService.request('Project/updateCompletion', {
            project: this.form.getRawValue(),
        }).subscribe(() => {
            this.toastrService.success('Erfolgreich gespeichert')
            this.setMode(ViewMode.VIEW);
            this.getProject();
            this.changeProject.emit();
        });
    }

    cancelEdit(): void {
        this.patchForm();
        this.setMode(ViewMode.VIEW);
    }
}
